/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Product variant — controls entitlement requirement and publisher billing.
 */
export type ProductVariant = typeof ProductVariant[keyof typeof ProductVariant];


export const ProductVariant = {
  full: 'full',
  demo: 'demo',
  preview: 'preview',
} as const;
